module.exports = __webpack_public_path__ + "img/section2@2x.16435ba5.png";